import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import {
    tituloEstudoResponsabilidadeCliente,
    tituloEstudoResponsabilidadeConjuge,
} from './EstudoService'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
} from '../../../business-components/Formata/Formata'

import {
    DivFormEstudo,
} from '../../../business-components/Div/Div'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    SvgIconProjetoVidaSonho,
} from '../../../business-components/SvgIcon/SvgIconDespesasTotais/SvgIconDespesasTotais'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    CardGridEstudoTabelaPadrao,
} from './EstudoComp'



const EstudoFormProjetoVidaSonho = ( { values, estudo, report, indInicial, indFinal } ) => {

    const ProjetoVidaSonho = () => {

        let headList = [
            {
                colSpan: 6,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.tipoProjetoVidaSonho, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valor, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.valorAcumulacaoJaRealizadoQuebraEspecial, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.valorAcumulacaoJaRealizadoVFQuebraEspecial, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.valorAcumulacaoPendenteQuebraEspecial, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.idadeAnoRealizacao, report),
            },
        ]

        if (dadosCompletosCliente(values)) {
            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                   tituloEstudoResponsabilidadeCliente(values), report
                               ),
                },
            )
        }
    
        if (dadosCompletosConjuge(values)) {
            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                   tituloEstudoResponsabilidadeConjuge(values), report
                               ),
                },
            )
        }

        return (
            <TableExibeDados
                report={report}
            >
                <TableHeadExibeDados
                    report={report}
                >
                    <TableRowHeadExibeDados
                        dados={headList}
                    />
                </TableHeadExibeDados>

                <TableBodyExibeDados>
                    {estudo.current.projetoVidaSonho?.map((item, ind) => {

                        let colSpan = 0

                        return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                            <TableRowBodyExibeDados
                                key={ind}
                                report={report}
                            >
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                    primeiraColuna={true}
                                >
                                    {item.descricao}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.valor}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.valorAcumulacaoJaRealizado}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.valorAcumulacaoJaRealizadoVF}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.valorAcumulacaoPendente}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.idadeAnoRealizacao}
                                </TableCellBodyExibeDados>

                                {dadosCompletosCliente(values) && (
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.valorResponsabilidadeCliente}
                                    </TableCellBodyExibeDados>
                                )}
                                
                                {dadosCompletosConjuge(values) && (
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.valorResponsabilidadeConjuge}
                                    </TableCellBodyExibeDados>
                                )}
                            </TableRowBodyExibeDados>
                        )
                    })}
                </TableBodyExibeDados>
            </TableExibeDados>
        )
    }

    return (
        <DivFormEstudo>
            {report || relatorioModoApresentacao(values)
                ?
                    //<div
                    //    className={(relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
                    //>
                        <ProjetoVidaSonho />
                    //</div>
                :
                    <CardGridEstudoTabelaPadrao
                        values={values}
                        SvgIcon={SvgIconProjetoVidaSonho}
                        label={LABEL.projetoVidaSonho}
                        helpTextMorte={HELPTEXT.estudoProjetoVidaSonhoMorte}
                        helpTextInvalidez={HELPTEXT.estudoProjetoVidaSonhoInvalidez}
                        component={<ProjetoVidaSonho/>}
                        popup={true}
                    />
            }
        </DivFormEstudo>
    )
}

export default EstudoFormProjetoVidaSonho